<template>
    <div id="loginPage">
        <div class="drapBox"></div>
        <div class="login-wrap" :style="{'background-image': 'url(' + bgimg + ')'}">
            <div class="login-box">
                <div class="login-th">股票交易系统</div>
                <div class="login-tline"></div>
                <div class="login-kuang">
                    <div class="kimg"><img src="~@/assets/images/corner@3x.png"/></div>
                    <div class="login-k-tlt">用户登录 V{{version}}</div>
                    <div class="login-k-box">
                        <div class="login-k-tb">
                            <div class="login-tb-lt">账&nbsp;&nbsp;&nbsp;&nbsp;号:</div>
                            <input type="text" v-model="userInfo.userName" class="login-tb-rt"/>

                        </div>
                        <div class="login-k-tb">
                            <div class="login-tb-lt">密&nbsp;&nbsp;&nbsp;&nbsp;码:</div>
                            <input type="password" v-model="userInfo.passWord" class="login-tb-rt"/>
                        </div>
                        <div class="login-k-tb">
                            <div class="login-tb-lt">验证码:</div>
                            <input type="text" v-model="userInfo.loginCode" class="login-tb-rt widt"/>
                            <div class="yzm" @click="refreshCode">
                                <Identify :identifyCode="identifyCode" :contentWidth="62"
                                          :contentHeight="32"></Identify>
                            </div>
                        </div>
                        <div class="xuan-btn-box">
                            <span @click="submitLogin()" class="xuan-btn">登录</span>
                            <span class="xuan-btn">取消</span>
                        </div>
                    </div>
                    <div class="error"></div>
                </div>
                <div class="zhuang-type">{{loginStaText}}</div>
            </div>
        </div>
        <transition name="errshow">
            <div class="pop-wrap pop-gai2" v-if="popGai2_show">
                <div class="error-box">
                    <div class="error-img"><img src="~@/assets/images/zhuyi@3x.png"/></div>
                    <div class="error-tlt">{{verificationText}}</div>
                    <div class="error-btn" @click="popGai2_show = false">确定</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import Identify from './LoginPageCode';
    import SubmitLogin from './LoginPageSubmit';
    import config from '../../../package.json'
    import utils from "../../common/utils";
    export default {
        name: "login",
        data: function () {
            return {
                version: config.version,
                userInfo: {loginCode: '', userName: localStorage.getItem('aword') ? utils.decrypt(localStorage.getItem('aword')) : '', passWord: localStorage.getItem('bword') ? utils.decrypt(localStorage.getItem('bword')) : ''},
                loginPopsShow: false,
                LoginPagePopGai_show: false,
                popGai2_show: false,
                nowPop: 1,
                rememberMe: false,
                identifyCodes: '1234567890abcdefjhijklinopqrsduvwxyz',
                identifyCode: '',
                verificationText: '',
                loginStaText: '准备登录',
                bgimg: null
            }
        },
        components: {Identify},
        methods: {
            // 刷新验证码
            refreshCode() {
                this.identifyCode = '';
                this.makeCode(this.identifyCodes, 4)
            },
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min)
            },
            // 创建验证码
            makeCode(o, l) {
                for (let i = 0; i < l; i++) {
                    this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
                }
            },
            // 登录方法
            ...SubmitLogin,
        },
        mounted() {
            // 初始化验证码
            this.identifyCode = '';
            this.makeCode(this.identifyCodes, 4);
            setTimeout(() => {
                this.bgimg = require('@/assets/images/bg@4x.png');
            }, 300)
        }
    }
</script>

<style scoped>
    #loginPage {
        height: 100vh;
    }
    .drapBox {
        position: absolute;
        height: 80px;
        width: calc(100vw - 80px);
        left: 0;
        top: 0;
        -webkit-app-region: drag;
    }

    .fade-enter-active, .fade-leave-active,
    .errshow-enter-active, .errshow-leave-active {
        transition: all .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
        height: 0;
    }

    .errshow-enter, .errshow-leave-to {
        opacity: 0;
    }
</style>
